module.exports = __webpack_public_path__ + "static/img/btm.4280d2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vcard/btm.jpg
// module id = JHCL
// module chunks = 1